import { I18nService } from './i18n.service';
import {
  ChangeDetectorRef,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { ReplacementArgs } from './replacement-args';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'i18n',
  pure: false,
})
export class I18nPipe implements PipeTransform, OnDestroy {
  private languageChangeSubscription: Subscription;

  constructor(
    private cdRef: ChangeDetectorRef,
    private i18nService: I18nService
  ) {
    // NOTE: We need to subscribe to language changes, so the template is re-rendered
    this.languageChangeSubscription = this.i18nService.languageChange.subscribe(
      () => {
        this.cdRef.markForCheck();
      }
    );
  }

  ngOnDestroy(): void {
    this.languageChangeSubscription.unsubscribe();
  }

  transform(messagePath: string, replacements?: ReplacementArgs): string {
    return this.i18nService.transform(messagePath, replacements);
  }
}
